const typeLabel = (type: string | undefined) => {
  if (type === undefined) {
    return 'Section'
  }
  return type === 'Middle8' ? 'Middle 8' : type
}

/**
 * Human section names in document order, as a musician would say them: a type
 * that repeats is numbered ("Verse 1", "Verse 2"), a type that occurs once is
 * not ("Chorus"). Shared by the section heading and the song structure map so
 * both name a section the same way.
 */
export const getSectionDisplayNames = (types: (string | undefined)[]): string[] => {
  const labels = types.map(typeLabel)
  const totals = new Map<string, number>()
  labels.forEach(label => totals.set(label, (totals.get(label) ?? 0) + 1))
  const seen = new Map<string, number>()
  return labels.map(label => {
    const n = (seen.get(label) ?? 0) + 1
    seen.set(label, n)
    return (totals.get(label) ?? 0) > 1 ? `${label} ${n}` : label
  })
}
